<template>
  <Modal v-model="isShow" class-name="vertical-center-modal">
    <div class="formDiv">
      <!-- <div class="fromItemImgContext">
        <img
          src="../../../public/static/image/mp-logo.png"
          class="fromItemImg"
        />
        <div class="fromItemTitle">MPai数据科学平台</div>
      </div> -->
      <Tabs :value="activeName" @on-click="clickTabs">
        <TabPane label="密码登录" name="login">
          <mpLogin v-if="activeName === 'login'"></mpLogin>
        </TabPane>
        <TabPane label="注册账号" name="reg">
          <mpReg v-if="activeName === 'reg'"></mpReg>
        </TabPane>
      </Tabs>
      <div class="privacy">
        注册/登入即代表同意<router-link to="/agreement" class="line" replace
          >《MPai数据科学平台用户协议》</router-link
        >和<router-link to="/privacy" class="line" replace
          >《隐私保护指引》</router-link
        >
      </div>
    </div>
  </Modal>
</template>
<script>
import mpLogin from "./mp-login.vue";
import mpReg from "./mp-reg.vue";
export default {
  components: {
    mpLogin,
    mpReg
  },
  computed: {
    activeName: {
      get() {
        return this.$store.state.activeName;
      },
      set(activeName) {
        this.$store.dispatch("commitActiveName", activeName);
      }
    },
    isShow: {
      get() {
        return this.$store.state.isShow;
      },
      set(isShow) {
        this.$store.dispatch("commitIsShow", isShow);
      }
    }
  },
  methods: {
    clickTabs(tabName) {
      this.activeName = tabName;
    },
    toPage() {
      this.$store.dispatch("commitIsShow", false);
    }
  }
};
</script>
<style>
.ivu-modal .ivu-tabs-ink-bar {
  display: none !important;
}
.ivu-modal .ivu-tabs-tab-active {
  border-bottom: 3px solid #2d8cf0;
}
@media screen and (min-width: 568px) {
  .ivu-modal {
    display: flex;
    justify-content: center;
  }
}
@media screen and (max-width: 568px) {
  .ivu-modal-wrap {
    display: flex;
    justify-content: center;
    align-items: self-start;
  }
  .ivu-modal {
    max-width: 65vw;
  }
}
.vertical-center-modal .ivu-modal-footer {
  display: none !important;
}
.vertical-center-modal .ivu-tabs-bar {
  border-bottom: none;
  margin-bottom: 0;
}
.vertical-center-modal .ivu-tabs-nav {
  font-size: 17px;
  font-weight: bold;
  letter-spacing: 2px;
}
.vertical-center-modal .ivu-tabs-nav .ivu-tabs-tab {
  font-weight: "微软雅黑", "Helvetica Neue", "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei";
}
.vertical-center-modal .ivu-tabs-nav-scroll {
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.vertical-center-modal .ivu-input {
  /* border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0px; */
}
.vertical-center-modal .ivu-input {
  /* background: red; */
}
</style>
<style lang="less" scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.privacy {
  font-size: 12px;
}
.fromItemImgContext {
  width: 100%;
  text-align: center;
  .fromItemImg {
    width: 80px;
    padding: 10px 0;
  }
}
.loginbody {
  width: 100vw;
  height: 100vh;
}

.formDiv {
  padding: 15px 40px;
}
.fromItemImgContext {
  width: 100%;
  text-align: center;
  .fromItemImg {
    width: 80px;
    padding: 10px 0;
  }
}
.fromItemTitle {
  font-size: 26px;
  font-weight: bold;
  padding-bottom: 10px;
  font-weight: "黑体";
}
</style>
